<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "../info.vue";
import Repair from "../repair.vue";
import Track from "../track.vue";
import Evaluatte from "../evaluate.vue";
import ExpenseAccount from "../expenseAccount.vue";
import EditPro from "@/views/amaiuser/workOrder/editProcessing";

export default {
  extends: baseList,
  components: {
    info: Info,
    Repair,
    Track,
    Evaluatte,
    EditPro,
    ExpenseAccount,
  },
  data() {
    return {
      makeMain: "",
      menu_name: "",

      table: {
        mname: "work",
        key: "id",
        url: {
          list: "/maintainer/maintainer/workOrder/list",
        },
        output: false,
        order: "repairTime",
      },
      actions: [],
      menus: [
        {
          label: "待处理",
          name: "workOrder_await_weixiu",
          auth: "system/workOrder/index",
          badge: {
            mname: "workstate",
            scene: "1",
            url: "/maintainer/maintainer/workOrder/state",
          },
        },
        {
          label: "处理中",
          name: "workOrder_processing_weixiu",
          auth: "system/processing/index",
          badge: {
            mname: "workstate",
            scene: "2",
            url: "/maintainer/maintainer/workOrder/state",
          },
        },
        {
          label: "已完成",
          name: "workOrder_completed_weixiu",
          auth: "system/completed/index",
        },
        {
          label: "抢单池",
          name: "seize_weixiu",
          badge: {
            mname: "workstate",
            scene: "4",
            url: "/maintainer/maintainer/workOrder/state",
          },
        },
      ],
      query: {
        state: 3,
      },
      filters: [
        {
          label: "报修时间",
          KeyEnter: this.search,
          name: "repairTime",
          value: "",
          type: "datetimerange",
        },
        {
          label: "工单类型",
          name: "typeName",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
        {
          label: "报修人电话",
          name: "repairPhone",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "报修人",
          KeyEnter: this.search,
          name: "repairBy",
          value: "",
          type: "input",
        },
        {
          label: "资产名称",
          name: "facilityName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "问题描述",
          KeyEnter: this.search,
          name: "descr",
          value: "",
          type: "input",
        },
        {
          label: "科室",
          name: "department",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "facilityNum",
          value: "",
          type: "input",
        },
        {
          label: "费用汇总",
          name: "expensesSum",
          value: "",
          type: "input",
        },
        {
          label: "报修方式",
          name: "repairType",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "电话报修",
            },
            {
              value: 2,
              name: "扫码报修",
            },
            {
              value: 3,
              name: "移动报修",
            },
            {
              value: 4,
              name: "后台设备报修",
            },
            {
              value: 5,
              name: "后台科室报修",
            },
            {
              value: 6,
              name: "维修员",
            },
            {
              value: 7,
              name: "用户PC普通",
            },
            {
              value: 8,
              name: "用户PC快速",
            },
          ],
        },
        {
          label: "产生费用",
          name: "expensesIncurred",
          value: 1,
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "是",
            },
            {
              value: 0,
              name: "否",
            },
          ],
        },
      ],
      tableCols: [
        /* {
          type: "selection",
          width: 60,
        }, */
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "问题描述",
          key: "descr",
          width: 280,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.descr;
            let tempDescr;
            if (text != null) {
              let arr = text.split("]");
              let tempDate = parseInt(arr[0]);
              if (tempDate < 60) {
                tempDescr = "[" + "0h" + tempDate + "m]" + arr[1];
              } else if (tempDate > 60 || tempDate == 60) {
                let hour = Math.floor(tempDate / 60);
                let min = tempDate % 60;
                tempDescr = "[" + hour + "h" + min + "m]" + arr[1];
              }
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: tempDescr,
                  },
                },
                tempDescr
              ),
            ]);
          },
        },
        {
          title: "工单类型",
          key: "typeName",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修时间",
          minWidth: 150,
          align: "center",
          key: "repairTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.repairTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "所在科室",
          key: "department",
          minWidth: 100,
          align: "left",
          tooltip: "true",
        },
        {
          title: "具体位置",
          key: "address",
          minWidth: 100,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修人",
          minWidth: 100,
          align: "left",
          key: "repairBy",
          sortable: true,
          tooltip: "true",
        },
        {
          title: "报修电话",
          key: "repairPhone",
          minWidth: 130,
          align: "left",
          copy: true,
        },

        {
          title: "协同工单",
          key: "isSynergy",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.isSynergy === 0 ? "否" : "是";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },

        {
          title: "费用",
          key: "expensesIncurred",
          minWidth: 100,
          align: "left",
        },
        {
          title: "状态",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.state === 3 ? "已完成" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "报修来源",
          key: "repairSource",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.repairSource === 1 && row.isFastOrder === 0
                ? "扫码报修"
                : row.repairSource === 1 && row.isFastOrder === 1
                ? "移动报修"
                : row.repairSource === 4
                ? "电话报修"
                : row.repairSource === 5 && row.isFastOrder === 0
                ? "用户PC普通"
                : row.repairSource === 5 && row.isFastOrder === 1
                ? "用户PC快速"
                : row.repairSource === 3 && row.isFastOrder === 0
                ? "后台设备报修"
                : row.repairSource === 3 && row.isFastOrder === 1
                ? "后台科室报修"
                : row.repairSource === 2
                ? "维修员"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 240,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = []
              return (
                <Button
                  size="small"
                  onClick={() => this.toEdit(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  写记录
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = []
              return (
                <Button
                  size="small"
                  onClick={() => this.toEvaluate(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  评价
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.toPrint(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  打印
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    this.loadLevelDatas();
    this.loaddeskData();
  },
  methods: {
    deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };

          $utils.api.load(`/maintainer/maintainer/desk/list`, q, "get").then((res) => {
            const list = res.rows.map((item) => {
              return {
                value: item.id,
                name: item.deskName,
              };
            });
            // let dropList = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);

            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "deskId") {
                this.filters[index]["dropList"] = list;
              }
            }
          });
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    loaddeskData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state = 2;
      $utils.api.load(`/maintainer/maintainer/desk/list`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "deskId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/maintainer/maintainer/workType/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.name;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeName") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    toRepair(row) {
      this.$Modal.success({
        closable: true,
        title: "送修记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Repair style={{ margin: "0", color: "#19be6b" }} workId={row.id}></Repair>
          );
        },
      });
    },
    toTrack(row) {
      this.$Modal.success({
        closable: true,
        title: "维修记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Track style={{ margin: "0", color: "#19be6b" }} workId={row.id}></Track>
          );
        },
      });
    },
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info_weixiu",
        query: { action: "edit", kv: row.id },
      });
    },
    toDel(currentRow) {},
    toImport() {},
    toDownload() {},
    toEvaluate(row) {
      this.$Modal.success({
        closable: true,
        title: "评价",
        width: "1000px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Evaluatte
              style={{ margin: "0", color: "#19be6b" }}
              workId={row.id}
            ></Evaluatte>
          );
        },
      });
    },
    toEdit(row) {
      this.$Modal.success({
        closable: true,
        title: "填写记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <EditPro
              style={{ margin: "0", color: "#19be6b" }}
              workId={row.id}
              typeId={row.typeId}
              state={row.state}
            ></EditPro>
          );
        },
      });
    },
    toPrint(row) {
      this.$Modal.success({
        closable: true,
        title: "打印",
        width: "1000px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ExpenseAccount style={{ margin: "0" }} workId={row.id}></ExpenseAccount>
          );
        },
      });
    },
  },
};
</script>
<style scoped></style>
